import React from "react";
import PropTypes from "prop-types";

import ButtonIcon from "../buttons/buttonIcon";
import * as buttonConstants from "../buttons/buttonConstants";
import TextArea from "../inputs/textArea";
import TextField from "../inputs/textField";

const MetadataEditForm = ({ config }) => {
    return (
        <tr>
            <td className={"align-top"}>
                <TextField config={{
                    name: "Key",
                    label: "Key",
                    maxLength: 100,
                    showLabel: false,
                    value: config.fields.Key,
                    error: (config.submitted && config.errors.Key) ? "*" : "",
                    isRequired: true
                }} />
            </td>
            <td>
                <TextArea config={{
                    name: "Value",
                    label: "Value",
                    value: config.fields.Value,
                    showLabel: false,
                    error: (config.submitted && config.errors.Value) ? "*" : "",
                    isRequired: true
                }} />
            </td>
            <td className={"text-center"}>
                <ButtonIcon config={{
                    name: "btnSave",
                    label: "Save",
                    iconType: buttonConstants.ICON_SAVE,
                    disabled: config.isLoading,
                    isSubmit: true
                }} />
                <ButtonIcon config={{
                    name: "btnCancel",
                    label: "Cancel",
                    onClick: config.onEditMetadataCancel,
                    iconType: buttonConstants.ICON_CANCEL,
                    disabled: config.isLoading
                }} />
                <input type={"hidden"} name={"Id"} value={config.fields.Id} />
            </td>
        </tr>
    );
};

MetadataEditForm.propTypes = {
    config: PropTypes.shape({
        metadata: PropTypes.object.isRequired,
        fields: PropTypes.object.isRequired,
        submitted: PropTypes.bool.isRequired,
        errors: PropTypes.object.isRequired,
        isLoading: PropTypes.bool,
        onEditMetadataCancel: PropTypes.func.isRequired
    })
};

export default MetadataEditForm;
